/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Merge_DownInputs */



/**
* | output |
* | --- |
* | "Merge Down" |
*
* @param {Shortcut_Keys_Name_Merge_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_merge_down = /** @type {((inputs?: Shortcut_Keys_Name_Merge_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Merge_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner vers le bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слияние вниз")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar hacia abajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向下合并")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下へマージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे विलय करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar para baixo")
	return /** @type {LocalizedString} */ ("Merge Down")
});